import { Injectable } from '@angular/core';
import { HttpClient } from '@angular/common/http';
import { Observable } from 'rxjs';
import { map } from 'rxjs/operators';
import { CrudService } from './crud.service';
import { ResolveSettings } from '../_models';

@Injectable()
export class ResolveSettingsService extends CrudService {
  constructor(protected http: HttpClient) {
    super(http, 'resolve_settings');
  }

  // The endpoint also lists per-merchant-profile copies; the account default is the one without a merchant profile.
  getAccountDefaultSettings(): Observable<ResolveSettings> {
    return this.list({ merchant_profile__isnull: true }).pipe(
      map((settings: ResolveSettings[]) => (settings && settings.length ? settings[0] : null))
    );
  }
}
